import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowRight, faArrowLeft } from '@fortawesome/free-solid-svg-icons'

library.add(faArrowRight, faArrowLeft);

class PaginationButton extends Component {
  render() {
    let direction

    this.props.next ? direction = 'arrow-right' : direction = 'arrow-left';

    return (
      <span className="pagination__button" onClick={ this.props.onClick }>
        <FontAwesomeIcon icon={ direction } />
      </span>
    )
  }
}

PaginationButton.propTypes = {
  onClick: PropTypes.func.isRequired
}

export default PaginationButton;



// WEBPACK FOOTER //
// ./src/components/pagination/button/index.js